import { useEffect } from 'react';
import StNavbar from "../components/StNavbar";
import StFooter from "../components/StFooter";
import { SetSeo } from '../lib/common_funcs';

import '../App2.css';
import '../redesign-2025.css';
import AOS from 'aos';
import 'aos/dist/aos.css';

function StQuotaExceeded() {

    const maintenanceSeo = {
        "title": "Domain Under Maintenance | TurboSteed",
        "description": "This domain is currently under maintenance.",
        "robots": "noindex, nofollow"
    }

    const allParams = {
        "seo": maintenanceSeo
    }

    useEffect(() => {
        AOS.init({
            duration: 800,
            once: true,
            easing: 'ease-out-cubic',
            offset: 50
        });
    }, []);

    return (
        <div className="ts-redesign">
            <SetSeo {...allParams} />
            <StNavbar />

            <header className="ts-page-hero">
                <div className="ts-hero-bg">
                    <div className="ts-gradient-orb ts-orb-1"></div>
                    <div className="ts-gradient-orb ts-orb-2"></div>
                </div>
                <div className="container">
                    <h1 className="ts-page-title" data-aos="fade-up">Domain Under Maintenance</h1>
                    <p className="ts-page-subtitle" data-aos="fade-up" data-aos-delay="100">We'll be back shortly</p>
                </div>
            </header>

            <main className="main-content">
                <section className="ts-section ts-section-light">
                    <div className="container">
                        <div className="row justify-content-center" data-aos="fade-up">
                            <div className="col-md-8 text-center">
                                <p className="mb-4">The domain you are visiting is currently under maintenance.</p>
                                <p className="mb-5">Please contact TurboSteed <a href="mailto:support@turbosteed.com">support</a> for more details.</p>
                                <a href="/" className="ts-btn ts-btn-primary mt-3">
                                    Go to Homepage
                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                        <path d="M5 12h14M12 5l7 7-7 7"/>
                                    </svg>
                                </a>
                            </div>
                        </div>
                    </div>
                </section>
            </main>

            <StFooter />
        </div>
    );
}

export default StQuotaExceeded;
